var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
import { DOCUMENT } from '@angular/common';
import { ComponentFactoryResolver, Inject } from '@angular/core';
// This class is used by apps outside of the securities app. It should be moved to ycharts/ycharts.
let DoVariableBootstrap = class DoVariableBootstrap {
    constructor(_document, componentFactoryResolver, allComponents) {
        this._document = _document;
        this.componentFactoryResolver = componentFactoryResolver;
        this.allComponents = allComponents;
        this.nonSingularComponents = [];
    }
    ngDoBootstrap(app) {
        this.nonSingularComponents.forEach((component) => {
            const factory = this.componentFactoryResolver.resolveComponentFactory(component);
            const nodes = this._document.querySelectorAll(factory.selector);
            nodes.forEach((node, idx) => {
                const id = `${factory.selector}-${idx}`;
                // Prepare each node with an unique ID that can be used with the selector
                node.setAttribute('id', id);
                const newSelector = `${factory.selector}[id=${id}]`;
                // Selector is a readonly property, so to override we would have to ts-ignore. Alternatively
                // we can use a Proxy object, which is less performant but this object should only be invoked
                // once per node at startup
                const proxyFactory = new Proxy(factory, {
                    get(target, prop, receiver) {
                        if (prop === 'selector') {
                            return newSelector;
                        }
                        return Reflect.get(target, prop, receiver);
                    },
                });
                app.bootstrap(proxyFactory);
            });
        });
        this.allComponents.forEach((component) => {
            if (this.nonSingularComponents.indexOf(component) === -1)
                app.bootstrap(component);
        });
    }
};
DoVariableBootstrap = __decorate([
    __param(0, Inject(DOCUMENT)),
    __metadata("design:paramtypes", [Object, ComponentFactoryResolver, Array])
], DoVariableBootstrap);
export { DoVariableBootstrap };
